// * @Description: 隐患排查记录
<template>
  <el-card class="h-full relative">
    <el-tabs v-model="activeName">
      <el-tab-pane label="设备设施类" name="equipment">
        <EquipCheckRecordsTable v-if="activeName === 'equipment'" />
      </el-tab-pane>
      <el-tab-pane label="作业活动类" name="work">
        <JobCheckRecordsTable v-if="activeName === 'work'" />
      </el-tab-pane>
      <el-tab-pane label="基础管理类" name="base">
        <BaseCheckRecordsTable v-if="activeName === 'base'" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import EquipCheckRecordsTable from '../components/CheckRecords/EquipCheckRecordsTable'
import JobCheckRecordsTable from '../components/CheckRecords/JobCheckRecordsTable'
import BaseCheckRecordsTable from '../components/CheckRecords/BaseCheckRecordsTable'

export default {
  name: 'check-records',
  components: {
    EquipCheckRecordsTable,
    JobCheckRecordsTable,
    BaseCheckRecordsTable,
  },
  data() {
    return {
      activeName: 'equipment',
    }
  },
  methods: {},
  mounted() {},
}
</script>
<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
